import { normalize } from 'normalizr';
import { omit } from 'ramda';

import { notify } from 'utils/reduxUtils';

import * as schema from './schema';
import * as types from './types';

export const initEditOrder = (payload) => ({
  type: types.INIT_EDIT_ORDER,
  payload: normalize(payload, schema.order),
});

export const updateOrder = {
  request: ({ orderId, data }) => ({
    type: types.ORDER_UPDATE_REQUEST,
    payload: { orderId, data },
  }),
  success: ({ order }) => {
    const normalized = normalize(order, schema.order);
    return {
      type: types.ORDER_UPDATE_SUCCESS,
      payload: {
        result: normalized.result,
        entities: omit(['parts'], normalized.entities),
      },
    };
  },
  error: notify(
    ({ error }) => ({
      type: types.ORDER_UPDATE_ERROR,
      payload: error,
    }),
    "Can't update this order",
  ),
};

export const copyOrderQuote = {
  request: ({ orderNumber }) => ({
    type: types.ORDER_COPY_REQUEST,
    payload: { orderNumber },
  }),
  success: () => ({
    type: types.ORDER_COPY_SUCCESS,
  }),
  error: notify(
    ({ error }) => ({
      type: types.ORDER_COPY_ERROR,
      payload: error,
    }),
    "Can't copy order",
  ),
};

export const createShipment = {
  flow: () => ({
    type: types.CREATE_SHIPMENT_FLOW,
  }),
  close: () => ({
    type: types.CREATE_SHIPMENT_CLOSE,
  }),
  setData: (payload) => ({
    type: types.CREATE_SHIPMENT_SET_DATA,
    payload,
  }),
  next: () => ({
    type: types.CREATE_SHIPMENT_NEXT,
  }),
  back: () => ({
    type: types.CREATE_SHIPMENT_BACK,
  }),
  proceedToSendInvoiceRequest: () => ({
    type: types.CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_REQUEST,
  }),
  proceedToSendInvoiceSuccess: ({
    emailTemplates,
    emailNotificationSettings,
  }) => ({
    type: types.CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_SUCCESS,
    payload: { emailTemplates, emailNotificationSettings },
  }),
  proceedToSendInvoiceError: (error) => ({
    type: types.CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_ERROR,
    payload: error,
  }),
  sendInvoiceRequest: (data) => ({
    type: types.CREATE_SHIPMENT_SEND_INVOICE_REQUEST,
    payload: { data },
  }),
  sendInvoiceSuccess: () => ({
    type: types.CREATE_SHIPMENT_SEND_INVOICE_SUCCESS,
  }),
  sendInvoiceError: (error) => ({
    type: types.CREATE_SHIPMENT_SEND_INVOICE_ERROR,
    payload: error,
  }),
  request: () => ({
    type: types.CREATE_SHIPMENT_REQUEST,
  }),
  success: (order) => ({
    type: types.CREATE_SHIPMENT_SUCCESS,
    payload: normalize(order, schema.order),
  }),
  error: (error) => ({
    type: types.CREATE_SHIPMENT_ERROR,
    payload: error,
  }),
};

export const downloadFiles = {
  request: (orderNumber) => ({
    type: types.DOWNLOAD_FILES_REQUEST,
    payload: { orderNumber },
  }),
  success: () => ({
    type: types.DOWNLOAD_FILES_SUCCESS,
  }),
  error: (error) => ({
    type: types.DOWNLOAD_FILES_ERROR,
    payload: error,
  }),
};

export const cancelOrder = {
  request: (orderId) => ({
    type: types.CANCEL_ORDER_REQUEST,
    payload: { orderId },
  }),
  success: () => ({
    type: types.CANCEL_ORDER_SUCCESS,
  }),
  error: () => ({
    type: types.CANCEL_ORDER_ERROR,
  }),
};

export const refundNotification = {
  flow: (orderNumber) => ({
    type: types.REFUND_NOTIFICATION_FLOW,
    payload: { orderNumber },
  }),
  openModal: (templates) => ({
    type: types.REFUND_NOTIFICATION_OPEN_MODAL,
    payload: { templates },
  }),
  close: () => ({
    type: types.REFUND_NOTIFICATION_CLOSE,
  }),
  request: (payload) => ({
    type: types.REFUND_NOTIFICATION_REQUEST,
    payload,
  }),
  success: () => ({
    type: types.REFUND_NOTIFICATION_SUCCESS,
  }),
  error: (error) => ({
    type: types.REFUND_NOTIFICATION_ERROR,
    payload: error,
  }),
};

export const exportInvoiceCsv = {
  request: () => ({
    type: types.EXPORT_INVOICE_CSV_REQUEST,
  }),
  success: () => ({
    type: types.EXPORT_INVOICE_CSV_SUCCESS,
  }),
  error: (error) => ({
    type: types.EXPORT_INVOICE_CSV_ERROR,
    payload: error,
  }),
};

export const updatePO = {
  request: (files) => ({
    type: types.UPDATE_PO_REQUEST,
    payload: { files },
  }),
  success: (order) => ({
    type: types.UPDATE_PO_SUCCESS,
    payload: normalize(order, schema.order),
  }),
  error: notify(
    (error) => ({
      type: types.UPDATE_PO_ERROR,
      payload: error,
    }),
    "Can't upload file for non purchase order.",
  ),
};
